import { tns } from "tiny-slider";

const galleries = Array.from(document.querySelectorAll(".product-gallery"));

function prepareGallery(el) {
    const container = el.querySelector('.product-gallery-inner')
    const controlsContainer= el.querySelector('.product-gallery-controls')
    const navContainer = el.querySelector('.product-gallery-navigation')

    tns({
        container,
        navContainer,
        controlsContainer
    })
}

function init() {
    if (!galleries) return;

    galleries.forEach(prepareGallery)
}

init();
